<div [class]="classes" [ngClass]="{'portlet-container':haveSideBar}"
  [@fullSize]="{value:fullSize,params:{normalWidth:normalSize.width,normalHeight:normalSize.height,normalTop:normalSize.top,normalLeft:normalSize.left,fullWidth:maximizedSize.width,fullHeight:maximizedSize.height,fullTop:maximizedSize.top,fullLeft:maximizedSize.left}}"
  (@fullSize.done)="fullSizeDone($event)" (@fullSize.start)="fullSizeStart($event)">
  <ng-content></ng-content>
</div>